import React from "react"
import {
  AddBoxOutlined as AddBoxOutlinedIcon,
  EditOutlined as EditOutlinedIcon,
  DeleteOutline as DeleteOutlineIcon,
} from "@mui/icons-material"
import Table from "../../ui/Table"

const ProductsTable = ({ items = [], onEdit, onDelete, onAdd, disabled = false }) => {
  const columns = [
    { id: 'name', label: 'Nome', render: (item) => item.name },
    { id: 'description', label: 'Descrição', render: (item) => item.description },
    {
      id: 'actions',
      label: '',
      align: 'right',
      render: (item) => (
        <div className="scout-settings-table__actions">
          <button
            type="button"
            className="scout-settings-icon-action"
            onClick={(event) => { event.stopPropagation(); if (!disabled) onEdit?.(item) }}
            disabled={disabled}
            title={disabled ? "Ação desabilitada" : "Editar"}
          >
            <EditOutlinedIcon />
          </button>
          <button
            type="button"
            className="scout-settings-icon-action"
            onClick={(event) => { event.stopPropagation(); if (!disabled) onDelete?.(item) }}
            disabled={disabled}
            title={disabled ? "Ação desabilitada" : "Excluir"}
          >
            <DeleteOutlineIcon />
          </button>
        </div>
      ),
    },
  ]

  return (
    <>
      <Table
        columns={columns}
        data={items}
        rowKey={(item) => item.id}
        tableClassName="scout-settings-table--editable"
        emptyMessage="Nenhum produto ou serviço encontrado."
      />

      <button type="button" className="scout-settings-add-row" onClick={() => { if (!disabled) onAdd?.() }} disabled={disabled}>
        <AddBoxOutlinedIcon />
        <span>Adicionar</span>
      </button>
    </>
  )
}

export default ProductsTable
